import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, InputNumber } from 'antd';

const { Option } = Select;

interface AffiliatorFormModalProps {
    visible: boolean;
    onOk: (values: any) => void;
    onCancel: () => void;
    initialData?: any;
}

const AffiliatorFormModal: React.FC<AffiliatorFormModalProps> = ({ visible, onOk, onCancel, initialData }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            if (initialData) {
                form.setFieldsValue({
                    name: initialData.name,
                    phone: initialData.phone,
                    email: initialData.email,
                    fee_type: initialData.fee_type,
                    fee_amount: initialData.fee_amount,
                });
            } else {
                form.resetFields();
            }
        }
    }, [visible, initialData, form]);

    const handleOk = () => {
        form.validateFields()
            .then((values) => {
                onOk(values);
            })
            .catch((info) => {
                console.log('Validate Failed:', info);
            });
    };

    return (
        <Modal
            visible={visible}
            title={initialData ? 'Edit Affiliator' : 'Tambah Affiliator'}
            okText={initialData ? 'Simpan Perubahan' : 'Tambah'}
            cancelText="Batal"
            onCancel={onCancel}
            onOk={handleOk}
        >
            <Form
                form={form}
                layout="vertical"
                name="affiliator_form"
            >
                <Form.Item
                    name="name"
                    label="Nama Lengkap"
                    rules={[{ required: true, message: 'Masukkan nama lengkap' }]}
                >
                    <Input placeholder="Nama Lengkap" />
                </Form.Item>

                <Form.Item
                    name="phone"
                    label="Nomor HP"
                    rules={[{ required: true, message: 'Masukkan nomor HP' }]}
                >
                    <Input placeholder="Contoh: 081234567890" />
                </Form.Item>

                <Form.Item
                    name="email"
                    label="Email"
                    rules={[{ required: true, type: 'email', message: 'Masukkan email yang valid' }]}
                >
                    <Input placeholder="Email" disabled={!!initialData} />
                </Form.Item>

                <Form.Item
                    name="password"
                    label="Password"
                    rules={[{ required: !initialData, message: 'Masukkan password' }]}
                >
                    <Input.Password placeholder={initialData ? "Kosongkan jika tidak ingin diubah" : "Password"} />
                </Form.Item>

                <Form.Item
                    name="fee_type"
                    label="Tipe Fee Komisi"
                    rules={[{ required: true, message: 'Pilih tipe fee' }]}
                >
                    <Select placeholder="Pilih Tipe Fee">
                        <Option value="PERCENTAGE">Persentase (%)</Option>
                        <Option value="FIXED">Nominal Tetap (Rp)</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="fee_amount"
                    label="Besaran Fee"
                    rules={[{ required: true, message: 'Masukkan besaran fee' }]}
                >
                    <InputNumber style={{ width: '100%' }} min={0} placeholder="Contoh: 5 (untuk 5%) atau 10000 (untuk Rp10.000)" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AffiliatorFormModal;
